import { ResponsiveBar } from '@nivo/bar'
import styles from "./style.module.scss";

export interface BarGraphProps<T extends Record<string, any>> {
  data: T[];
  valueKey: keyof T;
  indexKey: keyof T;
  height?: number;
  xLabel?: string;
  yLabel?: string;
  colorScheme?: string;
}

const BarGraph = <T extends Record<string, any>>(props: BarGraphProps<T>) => {
  const { data, indexKey, valueKey, xLabel = "", yLabel = "" } = props;

  const formattedData = data.map((d) => ({
    [indexKey]: d[indexKey],
    [valueKey]: d[valueKey],
  }));

  return (
    <div style={{ height: 400 }}>
      <ResponsiveBar
        data={formattedData}
        keys={[String(valueKey)]}
        indexBy={String(indexKey)}
        margin={{ top: 40, right: 40, bottom: 60, left: 60 }}
        padding={0.2}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={{ scheme: "nivo" }}
        borderColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 10,
          tickPadding: 5,
          tickRotation: 0,
          legend: xLabel,
          legendPosition: "middle",
          legendOffset: 40,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: yLabel,
          legendPosition: "middle",
          legendOffset: -55,
        }}
        enableLabel={true}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: "color",
          modifiers: [["darker", 1.8]],
        }}
        role="application"
        theme={{
          text: {
            color: "#333",
            fontSize: 12
          },
          axis: {
            domain: { line: { stroke: "#777", strokeWidth: 1 } },
          },
        }}
        tooltip={({ id, value, indexValue }) => (
          <div
            style={{
              background: "#fff",
              padding: "6px 8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          >
            <strong>{indexValue}</strong>: {value}
          </div>
        )}
        animate={true}
        motionConfig="gentle"
      />
    </div>
  )
}

export default BarGraph;